export const BACKGROUND_COLOR: Record<string, string> = {
  gray: '#f9f9f9',
  white: '#FFFFFF',
};
